// ==========================================
// PROPERTYHEROSEARCH.JSX - HERO WITH SEARCH
// Estate Experts Real Estate Website
// Hero section with property search form
// ==========================================

import React, { useState } from 'react';
import { FaSearch, FaChevronDown } from 'react-icons/fa';
import '../../../../assets/css/Buyer/Properties/PropertyHeroSearch.css'; // CSS file import

function PropertyHero() {
  // ==========================================
  // STATE MANAGEMENT
  // ==========================================
  
  // Active tab state - initially null (no tab active by default)
  const [activeTab, setActiveTab] = useState(null);
  
  // Search form state
  const [searchData, setSearchData] = useState({
    location: '',
    priceRange: '',
    bedsAndBaths: '',
    propertyType: '',
    propertyCategory: ''
  });

  // ==========================================
  // TABS DATA
  // ==========================================
  
  const tabs = ['Buy', 'Rent', 'Commercial'];

  // ==========================================
  // DROPDOWN OPTIONS
  // ==========================================
  
  const priceRanges = [
    'Any Price',
    'Under $100,000',
    '$100,000 - $250,000',
    '$250,000 - $500,000',

    '$500,000 - $1,000,000',
    '$1,000,000+'
  ];

  const bedsAndBathsOptions = [
    'Any',
    '1+ Bed, 1+ Bath',
    '2+ Beds, 2+ Baths',
    '3+ Beds, 2+ Baths',
    '4+ Beds, 3+ Baths',
    '5+ Beds, 4+ Baths'
  ];

   const propertyType = [
    'Buy',
    'Rent',
  ];


  const propertyCategory = [
    'Any Type',
    'House',
    'Apartment',
    'Villa',
    'Townhouse',
    'Plot',
    'Commercial',
    'Penthouse'
  ];

  // ==========================================
  // HANDLER FUNCTIONS
  // ==========================================
  
  // Handle tab click
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // Handle input change
  const handleInputChange = (field, value) => {
    setSearchData({
      ...searchData,
      [field]: value
    });
  };

  // Handle search submit
  const handleSearch = (e) => {
    e.preventDefault();
    
    console.log('Search Data:', {
      tab: activeTab,
      ...searchData
    });
    
    // You can add your search logic here
    // Example: redirect to search results page
    // window.location.href = `/properties?type=${activeTab}&location=${searchData.location}...`;
    
    alert(`Searching for ${activeTab || 'All'} properties...`);
  };

  // ==========================================
  // RENDER
  // ==========================================
  
  return (
    <>
    <section className="property-hero-search">
      
      {/* Background Image */}
      <div className="hero-search-background" />
      
      {/* Dark Overlay */}
      <div className="hero-search-overlay" />
      
      {/* Content Container */}
      <div className="hero-search-content">
        
        {/* Main Heading */}
        <h1 className="hero-search-heading">
        <span className="highlight-text">Properties</span>
        </h1>


        {/* Tab Buttons - Buy, Rent, Sell, Commercial */}
        <div className="hero-search-tabs">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => handleTabClick(tab)}
              className={`hero-tab-btn ${activeTab === tab ? 'active' : ''}`}
            >
              {tab}
            </button>
          ))}
        </div>
        
        {/* Search Form */}
        <form onSubmit={handleSearch} className="hero-search-form">
          
          {/* Where Field - Location Input */}
          <div className="form-field">
            <label className="field-label">Where</label>
            <input
              type="text"
              placeholder="Address, City or Zip"
              value={searchData.location}
              onChange={(e) => handleInputChange('location', e.target.value)}
              className="field-input"
            />
          </div>
          
          {/* Vertical Divider */}
          <div className="field-divider" />
          
          {/* Price Field - Dropdown */}
          <div className="form-field">
            <label className="field-label">Price</label>
            <div className="custom-select">
              <select
                value={searchData.priceRange}
                onChange={(e) => handleInputChange('priceRange', e.target.value)}
                className="field-select"
              >
                <option value="">Add price</option>
                {priceRanges.map((range) => (
                  <option key={range} value={range}>
                    {range}
                  </option>
                ))}
              </select>
              <FaChevronDown className="select-icon" />
            </div>
          </div>
          
          {/* Vertical Divider */}
          <div className="field-divider" />
          
          {/* Beds & Bath Field - Dropdown */}
          <div className="form-field">
            <label className="field-label">Beds & bath</label>
            <div className="custom-select">
              <select
                value={searchData.bedsAndBaths}
                onChange={(e) => handleInputChange('bedsAndBaths', e.target.value)}
                className="field-select"
              >
                <option value="">Add bed & bath</option>
                {bedsAndBathsOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
              <FaChevronDown className="select-icon" />
            </div>
          </div>
          

           {/* Vertical Divider */}
          <div className="field-divider" />
          
          {/* property - Dropdown */}
          <div className="form-field">
            <label className="field-label">property type</label>
            <div className="custom-select">
              <select
                value={searchData.propertyType}
                onChange={(e) => handleInputChange('propertyType', e.target.value)}
                className="field-select"
              >
                <option value="">Property type</option>
                {propertyType.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
              <FaChevronDown className="select-icon" />
            </div>
          </div>
          
          {/* Vertical Divider */}
          <div className="field-divider" />
          
          {/* Property Type Field - Dropdown */}
          <div className="form-field">
            <label className="field-label">Property Category</label>
            <div className="custom-select">
              <select
                value={searchData.propertyType}
                onChange={(e) => handleInputChange('propertyType', e.target.value)}
                className="field-select"
              >
                <option value="">Category</option>
                {propertyCategory.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </select>
              <FaChevronDown className="select-icon" />
            </div>
          </div>
          
          {/* Search Button - Circle with Icon */}
          <button 
            type="submit" 
            className="hero-search-btn"
            aria-label="Search Properties"
          >
            <FaSearch />
          </button>
        </form>
      </div>
    </section>
    </>
  );
}

export default PropertyHero;